var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('portal', [_c('div', _vm._b({
    ref: "modal",
    class: [_vm.className, _vm.contentClass],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close.apply(null, arguments);
      }
    }
  }, 'div', _vm.scopeAttrs, false), [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    },
    on: {
      "after-leave": _vm.emitClose
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "modal__overlay",
    on: {
      "click": _vm.close
    }
  }) : _vm._e()]), _c('transition', {
    attrs: {
      "name": _vm.transition,
      "appear": ""
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "modal__base"
  }, [_c('div', {
    staticClass: "modal__content"
  }, [_vm._t("default", null, {
    "onClose": _vm.close
  })], 2), !_vm.hideCloseButton ? _c('button', {
    staticClass: "modal__close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('close-icon', {
    staticClass: "modal__close-icon"
  })], 1) : _vm._e()]) : _vm._e()])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }